<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-07-10 16:28:36
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-07-10 16:32:41
 * @FilePath: \合联\oms\src\view\operation_modules\UnblockIntercept\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div style="padding: 10px; background-color: white; border-radius: 4px">
      <div style="max-width: 600px; margin: 0 auto">
        <cForm
          ref="form"
          :fields="fields"
          :grid="grid"
          :config="config"
        ></cForm>
      </div>
    </div>
    <div class="action">
      <Button @click="save" :loading="loading" type="primary">{{
        $tz("提交")
      }}</Button>
    </div>
  </div>
</template>

<script>
import cForm from "@/base/common/component/form.vue";
import { apis } from "@/api/operation_modules/unblockIntercept";
export default {
  name: "unblockIntercept",
  components: {
    cForm,
  },
  data() {
    return {
      loading: false,
      data: [],
      fields: [
        {
          name: () => this.$tz("订单号码"),
          key: "airway_number",
          component: "Input",
          placeholder: () => this.$tz("订单号码"),
        },
      ],
      grid: [
        {
          airway_number: 24,
        },
      ],
      config: {
        formBind: {
          labelWidth: 130,
        },
        colBind: {
          style: "margin-bottom:20px",
        },
        rules: {
          airway_number: [
            {
              required: true,
              message: this.$tz("不能为空"),
              trigger: "blur",
            },
          ],
        },
      },
    };
  },
  mounted() {},
  methods: {
    save() {
      this.loading = true;
      this.$refs["form"]
        .submit(true)
        .then((data) => {
          this.loading = false;
          apis.interceptUnblock(data).then((res) => {
            if (res.data.status) {
              this.$Message.success({
                content: res.data.message,
              });
              this.$refs["form"].clear();
            }
          });
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped lang="less">
.action {
  width: 100%;
  background-color: white;
  padding: 10px;
  border-radius: 4px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>